module.exports = __webpack_public_path__ + "images/89875cf23620b146f52d880a46db63a8.svg";